<file-pond #myPond
    [options]="pondOptions"
    [files]="pondFiles"
    (oninit)="pondHandleInit()"
    (onaddfilestart)="pondHandleStart()"
    (onaddfile)="pondHandleAddFile()"
    >
</file-pond>

